import * as Yup from "yup";
import { ObjectShape } from "yup/lib/object";
import { validateBr } from "js-brasil";
import { UsuarioSituacao, UsuarioTipo } from "./model";

export class UsuarioSchema {
  public static id() {
    return Yup
      .number()
      .positive("Id deve ser um numero positivo");
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static createForm() {
    const {
      nome,
      sobrenome,
      cpf,
      email,
      telefone,
      login,
      tipo,
      perfil,
      situacao,
      senha,
      confirmarSenha,
      dataInclusao,
    } = recordShape;

    const createFormShape = {
      nome,
      sobrenome,
      cpf,
      email,
      telefone,
      login,
      tipo,
      perfil,
      situacao,
      senha,
      confirmarSenha,
      dataInclusao,
    };

    return Yup
      .object()
      .shape(createFormShape);
  }

  public static updateForm() {
    const {
      nome,
      sobrenome,
      email,
      telefone,
      cpf,
      tipo,
      situacao,
      perfil,
      senha,
      confirmarSenha,
      alterarSenha,
    } = recordShape;

    const updateFormShape = {
      nome,
      sobrenome,
      email,
      telefone,
      cpf,
      tipo,
      situacao,
      perfil,
      senha: Yup.string()
        .when("alterarSenha", { is: true, then: senha }),
      confirmarSenha: Yup.string()
        .when("alterarSenha", { is: true, then: confirmarSenha }),
      alterarSenha,
    };

    return Yup
      .object()
      .shape(updateFormShape);
  }
}

const recordShape = {
  login: Yup
    .string()
    .matches(/^[a-z]/u, "Login iniciar com uma letra")
    .matches(/^[0-9a-z]+$/u, "Login deve conter apenas números e letras minúsculas")
    .min(5, "Login deve conter no mínimo 5 caracteres")
    .max(32, "Login deve conter no máximo 32 caracteres")
    .required("Obrigatório"),
  senha: Yup
    .string()
    .min(8, "Senha deve conter ao menos 8 caracteres")
    .max(16, "Senha deve conter no máximo 16 caracteres")
    .required("Senha é obrigatória"),
  confirmarSenha: Yup
    .string()
    .required("Confirmar senha é obrigatório")
    .oneOf([Yup.ref("senha")], "Senhas não conferem"),
  alterarSenha: Yup.boolean(),
  nome: Yup
    .string()
    .min(3, "Nome deve conter no mínimo 3 caracteres")
    .max(16, "Nome deve conter no máximo 16 caracteres")
    .required("Nome é obrigatório"),
  sobrenome: Yup
    .string()
    .min(3, "Sobrenome deve conter no mínimo 3 caracteres")
    .max(16, "Sobrenome deve conter no máximo 16 caracteres")
    .required("Sobrenome é obrigatório"),
  email: Yup.string()
    .email("Email inválido")
    .required("Email é obrigatório"),
  telefone: Yup
    .string()
    .test("telefone alg", "Telefone inválido", (telefone) => telefone && validateBr.telefone(telefone))
    .matches(/^[0-9]+$/u, "Telefone deve conter apenas números")
    .min(10, "Telefone deve conter no mínimo 10 dígitos")
    .max(11, "Telefone deve conter no máximo 11 dígitos")
    .required("Telefone é obrigatório"),
  cpf: Yup
    .string()
    .test("cpf alg", "CPF inválido", (cpf) => cpf && validateBr.cpf(cpf))
    .matches(/^[0-9]+$/u, "CPF deve conter apenas números")
    .length(11, "CPF deve conter 11 digitos")
    .required("CPF é obrigatório"),
  tipo: Yup
    .string()
    .oneOf(Object.values(UsuarioTipo))
    .required("Tipo é obrigatório"),
  situacao: Yup
    .string()
    .oneOf(Object.values(UsuarioSituacao))
    .required("Situação é obrigatório"),
  perfil: Yup
    .number()
    .required("Perfil é obrigatório"),
  dataInclusao: Yup
    .string()
    .matches(/^\d\d\d\d-\d\d-\d\d$/u, "Data inclusão inválida")
    .default(() => new Date()
      .toISOString()
      .split("T")[0]),
};
